import { render, staticRenderFns } from "./ContestInfo.vue?vue&type=template&id=66aa56f2&scoped=true&"
import script from "./ContestInfo.vue?vue&type=script&lang=js&"
export * from "./ContestInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContestInfo.vue?vue&type=style&index=0&id=66aa56f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aa56f2",
  null
  
)

export default component.exports